import { transport } from "@/src/config/apiConfig.js";

export default {
  async fetchSpaces(params) {
    try {
      let res = await transport.get(`/api/spaces`, { params: params });
      return res.data;
    } catch (error) {
      console.error("An error occurred while fetching spaces: ", error);
      throw error;
    }
  },

  async fetchSpaceByID(id) {
    try {
      let res = await transport.get(`/api/spaces/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while fetching spaces: ", error);
      throw error;
    }
  },

  async fetchSpacesWithRelationships(params) {
    try {
      let res = await transport.get(`/api/spaces/with-relationships`, {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching spaces with relationships: ",
        error,
      );
      throw error;
    }
  },

  async createSpace(payload) {
    try {
      let res = await transport.post(`/api/spaces`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating space: ", error);
      throw error;
    }
  },

  async updateSpace(id, payload) {
    try {
      let res = await transport.put(`/api/spaces/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating space: ", error);
      throw error;
    }
  },

  async deleteSpace(id) {
    try {
      let res = await transport.delete(`/api/spaces/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting space: ", error);
      throw error;
    }
  },

  async fetchWorkspaceNotes(workspaceId) {
    try {
      let res = await transport.get(`/api/workspaces/${workspaceId}/notes`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

};
